import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { http, errMsg } from "@/lib/api";
import { PageTitle } from "@/components/admin/AdminLayout";

const EMPTY = { name: "", description: "", color: "#7C3AED", order: 0, active: true };

export default function Categories() {
  const [cats, setCats] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => http.get("/admin/categories").then((r) => setCats(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    const { id, product_count, created_at, ...body } = edit;
    try {
      if (id) await http.put(`/admin/categories/${id}`, { ...body, order: Number(body.order) || 0 });
      else await http.post("/admin/categories", { ...body, order: Number(body.order) || 0 });
      toast.success("Categoria salva"); setEdit(null); load();
    } catch (err) { toast.error(errMsg(err)); }
  };
  const remove = async (c) => {
    if (!window.confirm(`Excluir a categoria "${c.name}"? Os produtos ficam sem categoria.`)) return;
    await http.delete(`/admin/categories/${c.id}`); toast.success("Categoria excluída"); load();
  };

  return (
    <div>
      <PageTitle title="Categorias" sub={`${cats.length} categorias`}>
        <button onClick={() => setEdit({ ...EMPTY, order: cats.length })} data-testid="admin-category-create-button" className="h-10 px-5 rounded-full bg-violet-600 hover:bg-violet-500 text-sm font-semibold inline-flex items-center gap-2"><Plus className="w-4 h-4" /> Nova categoria</button>
      </PageTitle>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="admin-category-list">
        {cats.map((c) => (
          <div key={c.id} className="rounded-2xl bg-[#111827] border border-white/10 p-5 flex items-center gap-4" data-testid={`admin-category-${c.id}`}>
            <span className="w-3 h-12 rounded-full" style={{ background: c.color }} />
            <div className="flex-1 min-w-0">
              <p className="font-heading font-bold truncate">{c.name}</p>
              <p className="text-xs text-slate-500">{c.product_count} produtos · {c.active ? "Visível" : "Oculta"}</p>
            </div>
            <button onClick={() => setEdit(c)} className="p-2 text-slate-400 hover:text-white" data-testid={`admin-category-edit-${c.id}`}><Pencil className="w-4 h-4" /></button>
            <button onClick={() => remove(c)} className="p-2 text-slate-400 hover:text-rose-400" data-testid={`admin-category-delete-${c.id}`}><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
      <Dialog open={!!edit} onOpenChange={(o) => !o && setEdit(null)}>
        <DialogContent className="bg-[#111827] border-white/10 text-slate-100">
          <DialogHeader><DialogTitle className="font-heading">{edit?.id ? "Editar categoria" : "Nova categoria"}</DialogTitle></DialogHeader>
          {edit && (
            <form onSubmit={save} className="space-y-4" data-testid="admin-category-form">
              <div className="space-y-2"><Label>Nome</Label><Input required value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} data-testid="admin-category-name-input" /></div>
              <div className="space-y-2"><Label>Descrição</Label><Input value={edit.description} onChange={(e) => setEdit({ ...edit, description: e.target.value })} data-testid="admin-category-description-input" /></div>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2"><Label>Cor</Label><input type="color" value={edit.color} onChange={(e) => setEdit({ ...edit, color: e.target.value })} className="w-full h-10 rounded-md bg-transparent border border-white/10" data-testid="admin-category-color-input" /></div>
                <div className="space-y-2"><Label>Ordem</Label><Input type="number" value={edit.order} onChange={(e) => setEdit({ ...edit, order: e.target.value })} data-testid="admin-category-order-input" /></div>
              </div>
              <div className="flex items-center gap-3"><Switch checked={edit.active} onCheckedChange={(v) => setEdit({ ...edit, active: v })} data-testid="admin-category-active-switch" /><Label>Visível na loja</Label></div>
              <button className="w-full h-11 rounded-full bg-violet-600 hover:bg-violet-500 font-semibold" data-testid="admin-category-save-button">Salvar</button>
            </form>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
